<template>
  <div class="map">
    <preloader-item v-if="loading"></preloader-item>
    <div class="map__left_menu">
      <div class="left_menu__layers">
        <button 
          class="layers_button">
          Точки
        </button>
        <button 
          class="layers_button"
          disabled
          >
          Полигоны
        </button>
        <button 
          class="layers_button"
          disabled
          >
          Линии
        </button>
        
      </div>
      <h3 class="left_menu__header1">Фильтры:</h3>
      <div class="left_menu__map_filters">
        <h4 class="left_menu__header2">
          Регионы:
        </h4>
        <ul class="map_filters__block">
          <li
          class="block_filter_item"
          v-for="(value, key) in this.all_regions"
          :key="key"
          >
            <label
            :for="'checkRegion' + key"
            class="filter_item_checkbox_label"
            >
            <input 
            type="checkbox"
            :value="key"
            :name="key"
            :id="'checkRegion' + key"
            v-model="checkedRegions"
            >
            {{ value }}
            <span class="checkmark">

            </span>
           </label>
          </li>
        </ul>
        <h4 class="left_menu__header2">
          Типы:
        </h4>
        <ul class="map_filters__block">
          <li
          class="block_filter_item"
          v-for="value in ['курган', 'курганная группа', 'могильник',
                          'городище', 'селище', 'стоянка', 'местонахождение',
                          'выработки', 'пещера', 'раскопан']"
          :key="value"
          >
            <label
            :for="'checkType' + value"
            class="filter_item_checkbox_label"
            >
            <input 
            type="checkbox"
            :value="value"
            :name="value"
            :id="'checkType' + value"
            v-model="checkedTypes"
            >
            {{ value }}
            <span class="checkmark">

            </span>
           </label>
          </li>
        </ul>
      <h4 class="left_menu__header2">
        Статусы:
      </h4>
      <ul class="map_filters__block">
          <li
          class="block_filter_item"
          v-for="(value, key) in {'федеральный': 'federal',
                                  'региональный': 'regional',
                                  'неучтенный': 'non-existent',
                                  'нет данных': null}"
          :key="key"
          >
            <label
            :for="'checkStatus' + key"
            class="filter_item_checkbox_label"
            >
            <input 
            type="checkbox"
            :value="value"
            :name="value"
            :id="'checkStatus' + key"
            v-model="checkedStatuses"
            >
            {{ key }}
            <span class="checkmark">

            </span>
           </label>
          </li>
        </ul>
        <h4 class="left_menu__header2">
        Точность координат:
        </h4>
        <ul class="map_filters__block">
          <li
          class="block_filter_item"
          v-for="(value, key) in {'точно': 1,
                                  'не точно': 0,
                                  'нет данных': null}"
          :key="key"
          >
            <label
            :for="'checkPrecision' + key"
            class="filter_item_checkbox_label"
            >
            <input 
            type="checkbox"
            :value="value"
            :name="value"
            :id="'checkPrecision' + key"
            v-model="checkedPrecision"
            >
            {{ key }}
            <span class="checkmark">

            </span>
           </label>
          </li>
        </ul>
      </div>
    </div>
    <div class="map__right_view">
      <div 
       class="preloader preloader_map"
       v-if="mapPreloader"
      >
        <span class="preloader__item preloader__item1"></span>
        <span class="preloader__item preloader__item2"></span>
        <span class="preloader__item preloader__item3"></span>
        <span class="preloader__item preloader__item4"></span>
      </div>
      <div 
       class="error_msg"
       v-if="error"
       >
        <span>{{ error }}</span>
      </div>
      <l-map 
      :zoom="zoom"
      :center="center"
      ref="map"
      @click="clickHandler">
        <l-tile-layer
        :visible="osm"           
        :url="'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'">
        </l-tile-layer>

        <l-tile-layer
        :visible="sat"
        :url="'http://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}'"
        :subdomains="['mt0','mt1','mt2','mt3']"
        ></l-tile-layer>

        <l-geo-json
        :geojson="points"
        :options="options"
        >
        </l-geo-json>
      
      </l-map>
      <div class="right_view__search">
        <div class="right_view__search_container">
          <input class="right_view__search_input" type="text" name="search_mem" v-model="memSearchString">
        </div>
        <ul class="mem_search_results" v-if="memSearchResults.length">
          <li
           class="mem_search_results_item"
           v-for="result in this.memSearchResults"
           :key="result['id']"
           @click="goToMem(result['geometry']['coordinates'])"
           >
             {{result.id}} | {{result.properties.name}}
           </li>
        </ul>
      </div>
      <div class="right_view__map_switcher">

        <div class="map_switcher_item">
          <input 
          type="radio"
          name="map"
          value="osm"
          v-model="tile"
          checked
          />
          <label class="map_switcher_label">OSM карта</label>
        </div>

        <div class="map_switcher_item">
          <input 
          type="radio"
          name="map"
          value="sat"
          v-model="tile"
          />
          <label class="map_switcher_label">Спутник</label>
        </div>
        
      </div>
      <div class="right_view__controls" v-if="state != 4">
        <div class="controls_cell">
          <input
          v-model="createState"
          type="checkbox"
          id="add"
          class="edit_check">
          <label for="add" class="edit_label">
              <div class="itool">
                  <span>Создать</span>
              </div>
          </label>
        </div>
        <div class="controls_cell">
          <input
          v-model="moveState"
          type="checkbox"
          id="move"
          class="move_check">
          <label for="move" class="edit_label">
              <div class="itool">
                  <span>Переместить</span>
              </div>
          </label>
        </div>
        <div class="controls_cell">
          <input
          v-model="deleteState"
          type="checkbox"
          id="delete"
          class="delete_check">
          <label for="delete" class="edit_label">
              <div class="itool">
                  <span>Удалить</span>
              </div>
          </label>
        </div>
        <div
         v-if="helpText"
         class="controls_help_text">
          <span 
           class="help_text"
          > 
          {{ this.helpText }} 
          </span>
        </div>
        <div 
         v-if="selectedForDelete"
         class="controls_delete_or_not">
         <span 
          class="help_text"
          >Вы точно этого хотите?</span>
          <div class="delete_or_not_buttons">
            <button 
             class="delete_or_not_button"
             @click="closeDelete"
            >
              Нет
            </button>
            <button 
             class="delete_or_not_button_yes"
             @click="handleDelete"
            >
             
              Да
            </button>
          </div>
        </div>
      </div>
      <div 
       class="right_view_create_form"
       v-if="(this.createForm)">
        <form
         class="create_form"  
         @submit.prevent="submitCreatePoint($event)"
         >
          <button class="create_form_close" @click="closeCreateForm">X</button>
          <label class="create_form_label" for="createName">Название*</label>
          <input class="create_form_input" name="name" id="createName" required>

          <label class="create_form_label" for="createRegion">Регион*</label>
          <select class="create_form_select" name="region" id="createRegion" required>
            <option 
             v-for="(value, key) in this.all_regions"
             :key="key"
             :value="key"
             >
             {{ value }}
            </option>
          </select> 

          <label class="create_form_label" for="createDistrict">Район*</label>
          <input class="create_form_input" name="district" id="createDistrict" required>

          <label class="create_form_label" for="createType">Тип*</label>
          <select class="create_form_select" name="type" id="createType" required>
            <option 
             v-for="value in this.allTypes"
             :key="value"
             :value="value"
             >
             {{ value }}
            </option>
          </select>

          <label class="create_form_label" for="createStatus">Статус*</label>
          <select class="create_form_select" name="status" id="createStatus" required>
            <option 
             v-for="(value, key) in this.allStatuses"
             :key="key"
             :value="key"
             >
             {{ value }}
            </option>
          </select>

          <label class="create_form_label" for="createPrecision">Точность положения*</label>
          <select class="create_form_select" name="precision" id="createPrecision" required>
            <option 
             v-for="(value, key) in this.allPrecisions"
             :key="key"
             :value="key"
             >
             {{ value }}
            </option>
          </select>

          <label class="create_form_label" for="createOrder">Документ о включении</label>
          <input class="create_form_input" name="order" id="createOrder">

          <label class="create_form_label" for="createDescription">Краткое описание</label>
          <input class="create_form_input" name="description" id="createDescription">

          <label class="create_form_label" for="createX">
            Координаты
          </label>
          <div class="create_form_wrapper">
            <div class="form_wrapper_cell">
              <label class="create_form_label" for="form_X">X*:</label>
              <input :value="clickedCoordsX" class="create_form_coord_input" name="x" id="form_X" required>
            </div>
            <div class="form_wrapper_cell">
              <label class="create_form_label" for="form_Y">Y*:</label>
              <input :value="clickedCoordsY" class="create_form_coord_input" name="y" id="form_Y" required>
            </div>
          </div>

          <button type="submit" class="create_form_button">
            Создать
          </button>
        </form>
      </div>
    </div>
    <map-detail 
     v-if="show_detail"
     :fid="selectedPoint"
     :token="token"
     :state="state"
     @toggle-detail="closeDetailHandler"
     ></map-detail>
  </div>
</template>
<script>
import { LMap, LTileLayer, LGeoJson } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import { icons } from "@/map_utils/iconsObject";
import router from '@/router';
import PreloaderItem from '././preloader.vue';
import mapDetail from '././mapDetail.vue';
import {getState} from '@/hub/auth';
import {getPoints, getRegions, createPoint, movePoint, deletePoint} from '@/api/mapItems'
export default {
  name: 'MapPage',
  components: {
    PreloaderItem,
    mapDetail,
    LMap,
    LTileLayer,
    LGeoJson
  },
  props: {
    msg: String,
  },
  data(){
    return{
      token: null,
      loading: true,
      mapPreloader: false,
      state: null,
      error: null,

      tile: 'osm',
      osm: true,
      sat: false,
      zoom: 7,
      center: [54.527612, 51.387796],
      all_regions: null,
      points: null,

      checkedRegions: ['73',],
      checkedTypes: ['курган', 'курганная группа', 'могильник',
                     'городище', 'селище', 'стоянка', 'местонахождение',
                     'выработки', 'пещера', 'раскопан'],
      allTypes: ['курган', 'курганная группа', 'могильник',
                 'городище', 'селище', 'стоянка', 'местонахождение',
                 'выработки', 'пещера', 'раскопан'],
      checkedStatuses: ['federal', 'regional', 'non-existent', null],
      allStatuses: {'federal': 'федеральный', 'regional': 'региональный', 
                    'non-existent': 'не учтенный'},
      checkedPrecision: [1, 0, null],
      allPrecisions: {1: 'точно', 0: 'не точно'},

      moveState: false,
      deleteState: false,
      createState: false,
      readyToMove: false,
      helpText: null,
      createForm: false,
      selectedForDelete: false,

      clickedCoordsX: null,
      clickedCoordsY: null,
      selectedPoint: null,

      show_detail: false,

      memSearchString: '',
      memSearchResults: [],
    };
  },
  methods: {
    async reloadPoints(token, regions){
      const pointsData = await getPoints(token, regions);
      if(pointsData){
        localStorage.setItem("points", JSON.stringify(pointsData));
        this.points = JSON.parse(localStorage.getItem("points"));
      }
    },
    async getAllRegions(token){
      if(!localStorage.getItem("all_regions") || localStorage.getItem("all_regions") == 'false'){
        const all = await getRegions(token)
        if(all){
          localStorage.setItem("all_regions", JSON.stringify(all))
        }else{
          this.error = 'Сервис временно недоступен'
        }
        return all
      }
      else{
        return JSON.parse(localStorage.getItem("all_regions"))
        
      }
      
    },
    filters(){
      const features = JSON.parse(localStorage.getItem("points"))
      
      const filteredTfeatures = features.features.filter(element => 
      this.checkedTypes.includes(element.properties.type))
      features.features = filteredTfeatures
      
      
      const filteredSfeatures = features.features.filter(element => 
      this.checkedStatuses.includes(element.properties.status))
      features.features = filteredSfeatures
    
      
      const filteredPfeatures = features.features.filter(element => 
      this.checkedPrecision.includes(element.properties.pos))
      features.features = filteredPfeatures
      
      this.points = features
    },
    async filtersRegions(){
      this.mapPreloader = true
      await this.reloadPoints(this.token, this.checkedRegions.toString())
      this.filters()
      this.mapPreloader = false
    },
    onEachFeatureFunction(feature, layer) {
      layer.setIcon(icons.iconStable);
      layer.bindTooltip(
        "<div class='mapItem_font'>" +
          feature.properties.name +
          "</div>",
        { permanent: false, sticky: true }
      );
      layer.on({
        click: this.objectClickHandler
      });
      layer.on("mouseover", function(){
        layer.setIcon(icons.iconSelected);
      });
      layer.on("mouseout", function(){
        layer.setIcon(icons.iconStable);
      });
    },
    objectClickHandler(e){
      this.selectedPoint = e.target.feature.id
      if(this.moveState){
        this.$refs.map.$el.classList.add("leaflet-crosshair");
        this.helpText = 'Выберите куда переместить';
        this.readyToMove = true
      }
      if(this.deleteState){
        this.helpText = null;
        this.selectedForDelete = true;
      }
      if(!this.deleteState & !this.moveState){
        this.show_detail = true
      }
    },
    async clickHandler(event){
      if(this.createState){
        this.helpText = 'Заполните данные и нажмите <Создать>'
        this.clickedCoordsX = event.latlng.lat
        this.clickedCoordsY = event.latlng.lng
        this.createForm = true;
      }
      if(this.readyToMove){
        this.mapPreloader = true
        this.helpText = null;
        this.clickedCoordsX = event.latlng.lat
        this.clickedCoordsY = event.latlng.lng
        let result = await movePoint(this.token, {"fid": this.selectedPoint,
                                                  "x": this.clickedCoordsX,
                                                  "y": this.clickedCoordsY})
        if(result){
          await this.filtersRegions()
        }
        else{
          this.error = 'Сервис временно недоступен'
        }
        this.moveState = false;
        this.readyToMove = false;
        this.mapPreloader = false;
      }
    },
    closeCreateForm(){
      this.createForm=false;
      this.helpText=null;
      this.createState=false;
    },
    closeDelete(){
      this.selectedForDelete = false;
      this.deleteState = false;
    },
    async submitCreatePoint(event){
      this.mapPreloader = true
      this.createForm = false
      this.createState=false;
      let result = await createPoint(this.token, event.target)
      if(result){
        await this.filtersRegions()
      }else{
        this.error = 'Сервис временно недоступен'
      }
      this.mapPreloader = false
    },
    async handleDelete(){
      this.mapPreloader = true;
      let deleted = await deletePoint(this.token, 
                           {'fid': this.selectedPoint})
      if(deleted){
        await this.filtersRegions()
      }else{
        this.error = 'Сервис временно недоступен'
      }
      this.selectedPoint = null;
      this.selectedForDelete = false;
      this.deleteState = false;
      this.mapPreloader = false;
    },
    closeDetailHandler(){
      this.show_detail = false
    },
    async searchMem(value){
      this.points.features.forEach(element => {
        if(element.properties.name.toLowerCase().includes(value.toLowerCase())){
          this.memSearchResults.push(element)
        }
      })
    },
    async goToMem(coords){
      coords = [coords[1], coords[0]]
      this.center = coords
      await new Promise(r => setTimeout(r, 300));
      this.zoom += 5
    }
  },
  watch: {
    tile() {
      if (this.tile == 'osm'){
        this.osm = true;
        this.sat = false;
      }else{
        this.osm = false;
        this.sat = true;
      }
    },
    checkedRegions(){
      this.filtersRegions()
    },
    checkedTypes(){
      this.filters()
    },
    checkedStatuses(){
      this.filters()
    },
    checkedPrecision(){
      this.filters()
    },
    createState(){
      if(this.createState){
        this.deleteState = false;
        this.moveState = false;
        this.$refs.map.$el.classList.add("leaflet-crosshair");
        this.helpText = 'Укажите место на карте для создания объекта'
      }else{
        if(!this.createState && !this.moveState && !this.deleteState){
          this.helpText = null;
        }
        this.$refs.map.$el.classList.remove("leaflet-crosshair");
        this.createForm = false;
      }
    },
    moveState(){
      if(this.moveState){
        this.deleteState = false;
        this.createState = false;
        this.helpText = 'Выберите объект'
      }else{
        if(!this.createState && !this.moveState && !this.deleteState){
          this.helpText = null;
        }
        this.$refs.map.$el.classList.remove("leaflet-crosshair");
        this.readyToMove = false;
        this.selectedPoint = null;
      }
    },
    deleteState(){
      if(this.deleteState){
        this.moveState = false;
        this.createState = false;
        this.helpText = 'Выберите объект'
      }else{
        if(!this.createState && !this.moveState && !this.deleteState){
          this.helpText = null;
        }
      }
    },
    memSearchString(){
      this.memSearchResults = []
      if(this.memSearchString.length > 2){
        this.searchMem(this.memSearchString)
      }
    }
  },
  computed: {
    options(){
      return{
        onEachFeature: this.onEachFeatureFunction,
      }
    }
  },
  async created(){
    this.token = localStorage.getItem('ArgoToken')
    if(this.token){

      this.email = localStorage.getItem('ArgoUserEmail')

      this.state = await getState(this.email, this.token)

      if(!this.state){
        this.loading = false
        router.push({name: 'login'})
      }
      
      this.all_regions = await this.getAllRegions(this.token)
      
      await this.reloadPoints(this.token, this.checkedRegions.toString())
      
      this.loading=false

      await this.filtersRegions()
      
    }

    else{

      this.loading = false
      
      router.push({name: 'login'})
    }
    
  }
}
</script>